import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Address, AddressCreate, AddressFilter } from '../data/address';

export function createAddressService(client: AxiosInstance) {
  return createCrudService<Address, AddressCreate, AddressFilter>(
    client,
    '/master-data/Address',
    'id',
  );
}

export type AddressService = CrudService<Address, AddressCreate, AddressFilter>;
